import Icons, {IconTypes} from "assets/icons";

type IconProps = {
  id: keyof IconTypes,
  [key:string]: any
};

const allIcons = Icons;

const Icon = ({ id, ...props }: IconProps): JSX.Element | null => {
  const selectedIcon = allIcons[id];
  return selectedIcon ? selectedIcon(props) : null;
};

export default Icon;
export type { IconTypes }
